var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEscalatorWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1302_96",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 10,
    height: 10
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1302_96)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.70833 2.49992C2.47917 2.49992 2.28299 2.41832 2.11979 2.25513C1.9566 2.09193 1.875 1.89575 1.875 1.66659C1.875 1.43742 1.9566 1.24124 2.11979 1.07804C2.28299 0.914849 2.47917 0.833252 2.70833 0.833252C2.9375 0.833252 3.13368 0.914849 3.29688 1.07804C3.46007 1.24124 3.54167 1.43742 3.54167 1.66659C3.54167 1.89575 3.46007 2.09193 3.29688 2.25513C3.13368 2.41832 2.9375 2.49992 2.70833 2.49992ZM7.08333 4.58325C6.90972 4.58325 6.76215 4.52249 6.64063 4.40096C6.5191 4.27943 6.45833 4.13186 6.45833 3.95825C6.45833 3.78464 6.5191 3.63707 6.64063 3.51554C6.76215 3.39402 6.90972 3.33325 7.08333 3.33325C7.25694 3.33325 7.40451 3.39402 7.52604 3.51554C7.64757 3.63707 7.70833 3.78464 7.70833 3.95825C7.70833 4.13186 7.64757 4.27943 7.52604 4.40096C7.40451 4.52249 7.25694 4.58325 7.08333 4.58325ZM1.875 9.16658V6.24992H1.25V3.74992C1.25 3.52075 1.3316 3.32457 1.49479 3.16138C1.65799 2.99818 1.85417 2.91659 2.08333 2.91659H3.33333C3.48611 2.91659 3.625 2.95304 3.75 3.02596C3.875 3.09888 3.97569 3.20131 4.05208 3.33325L5.54167 5.90617L5.96875 5.27075C6.02431 5.18742 6.09896 5.12145 6.19271 5.07284C6.28646 5.02422 6.38542 4.99992 6.48958 4.99992H7.70833C7.88194 4.99992 8.02951 5.06068 8.15104 5.18221C8.27257 5.30374 8.33333 5.45131 8.33333 5.62492V7.08325H7.91667V9.16658H6.25V6.20825L5.92708 6.66658H5.01042L3.95833 4.83325V9.16658H1.875Z",
    fill: "#F58634"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEscalatorWarning);
export default __webpack_public_path__ + "static/media/escalator_warning.53d4f3d2bae75ef2bd9652803e1a2848.svg";
export { ForwardRef as ReactComponent };